// apps/web/src/pages/vendas/precos/badge-estado-versao.tsx — Fase 12, Plano 06 (PV-09).
// Estado da versão de preço com cor + ícone + texto: Vigente (emerald), Futura (blue), Encerrada (slate).
import { Archive, CalendarClock, CheckCircle2 } from 'lucide-react';
import type { EstadoVersaoPreco } from '@pieltec/contracts';
import { rotuloEstadoVersao } from '../../../lib/vendas/precos';

const ICONES_ESTADO = { CheckCircle2, CalendarClock, Archive } as const;

const CLASSES_ESTADO: Record<EstadoVersaoPreco, string> = {
  VIGENTE: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  FUTURA: 'border-blue-200 bg-blue-50 text-blue-800',
  ENCERRADA: 'border-slate-200 bg-slate-100 text-slate-700',
};

export function BadgeEstadoVersao({ estado }: { readonly estado: EstadoVersaoPreco }) {
  const { texto, icone } = rotuloEstadoVersao(estado);
  const Icone = ICONES_ESTADO[icone];
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${CLASSES_ESTADO[estado]}`}>
      <Icone className="size-3.5" aria-hidden="true" />
      {texto}
    </span>
  );
}
